var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMealCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    fill: "#FFF9DD",
    stroke: "#FFE673",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.693 22.4749H9.31341C9.02693 22.4749 8.83594 22.2521 8.83594 21.9656C8.83594 21.6791 9.05876 21.4563 9.31341 21.4563H14.693C14.9795 21.4563 15.2023 21.6791 15.2023 21.9656C15.2023 22.2521 14.9795 22.4749 14.693 22.4749Z",
    fill: "url(#paint0_linear_1351_3021)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0878 25.7532H10.6259C10.3394 25.7532 10.1484 25.5304 10.1484 25.2439C10.1484 24.9574 10.3713 24.7346 10.6259 24.7346H17.0878C17.3743 24.7346 17.5653 24.9574 17.5653 25.2439C17.5653 25.5304 17.3424 25.7532 17.0878 25.7532Z",
    fill: "url(#paint1_linear_1351_3021)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6988 28.9046H9.00091C8.71443 28.9046 8.52344 28.6818 8.52344 28.3953C8.52344 28.1088 8.74626 27.886 9.00091 27.886H14.6988C14.9853 27.886 15.2081 28.1088 15.2081 28.3953C15.2081 28.6818 14.9853 28.9046 14.6988 28.9046Z",
    fill: "url(#paint2_linear_1351_3021)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0264 28.459C31.0264 27.6951 31.663 27.0584 32.427 27.0584H39.4936C38.284 23.0476 34.7825 20.1827 30.6444 19.7053C30.5171 19.6734 30.3579 19.6734 30.2306 19.6734C29.9759 19.6416 29.6894 19.6416 29.4348 19.6416C29.2119 19.6416 28.9573 19.6416 28.7345 19.6734C28.7026 19.6734 28.639 19.6734 28.6071 19.6734C28.3843 19.7053 28.1615 19.7053 27.9387 19.7371C22.8138 20.4692 18.8984 24.8302 18.8984 30.1143C18.8984 30.6236 18.9303 31.1011 18.9939 31.5785H31.0582V30.7191V28.459H31.0264Z",
    fill: "url(#paint3_linear_1351_3021)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2323 18.9099H30.3596C30.6143 18.9099 30.8371 18.9417 31.0918 18.9736H31.1236C31.1554 18.8781 31.1554 18.7826 31.1554 18.6871C31.1554 17.764 30.3915 17 29.4683 17C28.5452 17 27.7812 17.764 27.7812 18.6871C27.7812 18.7826 27.7812 18.8781 27.8131 18.9736C28.3542 18.9099 28.9272 18.8781 29.4683 18.8781C29.6912 18.8781 29.9458 18.8781 30.2323 18.9099Z",
    fill: "url(#paint4_linear_1351_3021)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0156 32.088V38.2315C32.0156 38.4543 32.2066 38.6453 32.4294 38.6453H47.5814C47.8042 38.6453 47.9952 38.4543 47.9952 38.2315V31.2285H32.0156V32.088ZM37.7772 36.0351H39.4961C39.7826 36.0351 39.9736 36.2579 39.9736 36.5444C39.9736 36.8309 39.7508 37.0537 39.4961 37.0537H37.7772C37.4907 37.0537 37.2997 36.8309 37.2997 36.5444C37.2997 36.2579 37.4907 36.0351 37.7772 36.0351ZM33.8619 36.0351H35.5808C35.8673 36.0351 36.0901 36.2579 36.0901 36.5444C36.0901 36.8309 35.8673 37.0537 35.5808 37.0537H33.8619C33.5754 37.0537 33.3526 36.8309 33.3526 36.5444C33.3526 36.2579 33.5754 36.0351 33.8619 36.0351Z",
    fill: "url(#paint5_linear_1351_3021)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4294 28.0459C32.2066 28.0459 32.0156 28.2369 32.0156 28.4597V30.2105H47.9952V28.4597C47.9952 28.2369 47.8042 28.0459 47.5814 28.0459H40.1646H32.4294Z",
    fill: "url(#paint6_linear_1351_3021)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0275 31.5789H16.3212C16.0666 31.5789 15.8438 31.8017 15.8438 32.0882C15.8438 32.3747 16.0666 32.5975 16.3212 32.5975H31.0275V31.5789Z",
    fill: "url(#paint7_linear_1351_3021)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_3021",
    x1: 10.3089,
    y1: 22.0322,
    x2: 15.1565,
    y2: 22.0249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_3021",
    x1: 11.8645,
    y1: 25.3105,
    x2: 17.5119,
    y2: 25.3007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_3021",
    x1: 10.0701,
    y1: 28.4619,
    x2: 15.1601,
    y2: 28.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1351_3021",
    x1: 23.6635,
    y1: 26.3906,
    x2: 39.3456,
    y2: 26.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1351_3021",
    x1: 28.5619,
    y1: 18.1158,
    x2: 31.1312,
    y2: 18.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1351_3021",
    x1: 35.7128,
    y1: 35.4219,
    x2: 47.8804,
    y2: 35.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1351_3021",
    x1: 35.7128,
    y1: 29.2697,
    x2: 47.8803,
    y2: 29.2482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1351_3021",
    x1: 19.3568,
    y1: 32.1548,
    x2: 30.9183,
    y2: 32.1134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealCards);
export default __webpack_public_path__ + "static/media/Meal Cards.38eca0a74de58ba03f70077a7f096610.svg";
export { ForwardRef as ReactComponent };